module.exports = __webpack_public_path__ + "img/madelegabel.fb6bae70.jpg";